import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import PublicRoutes from './PublicRoutes';

const isPublicRoute = (pathname: string): boolean => {
  return pathname.startsWith('/broadcast-recipient/');
};

interface IAppRoutesProps {
  children: React.ReactNode;
}

export const AppRoutes = ({ children }: IAppRoutesProps) => {
  const location = useLocation();

  if (isPublicRoute(location.pathname)) {
    return (
      <Routes>
        <Route path="/broadcast-recipient/:token/*" element={<PublicRoutes />} />
      </Routes>
    );
  }

  return <>{children}</>;
};
